import { DataType } from '../../../types';

export const isNumber = (dataType: DataType) => {
  return dataType === DataType.Price || dataType === DataType.Number;
};
